export default __webpack_public_path__ + "img/olivertree_closet-01.0677fb98cf296b1118d3919dbf400098.png";